import { createContext, useContext, useState, useCallback } from "react";

export const LANGS = [
  { id: "en", short: "EN", label: "English" },
  { id: "hi", short: "हि", label: "हिन्दी" },
  { id: "hinglish", short: "Hi", label: "Hinglish" },
];

const LanguageContext = createContext({ lang: "en", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("en");
  const setLang = useCallback((next) => setLangState(next), []);
  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
